<template>
  <div
    class="audio-item-subscribe-box"
    :class="{
      [`audio-item-subscribe-box--${createRenderType}`]: true,
      'audio-item-subscribe-box-first': props.index == 0,
    }"
  >
    <div
      class="audio-item-subscribe-mobile"
      v-if="createRenderType == 'mobile'"
    >
      <!-- <div class="audio-item-subscribening">
        <i class="block"></i>
      </div> -->

      <div class="audio-item-subscribe-rolling-box flex1 width-0">
        <el-carousel
          :interval="3000"
          :autoplay="true"
          height="100%"
          :pause-on-hover="false"
          direction="vertical"
        >
          <el-carousel-item
            v-for="(item, index) in constGuid.rollingTextDatasMapMobile[
              $$language()
            ]"
            :key="index"
          >
            <div class="audio-item-subscribe-rolling-text omlh-2">
              {{ item }}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="audio-item-subscribes">
        <div class="fn-inline audio-item-subscribe">
          <Button
            @click="doSubscribe"
            :renderStyle="{
              '--padding': '0 8px',
              '--width': 'max-content',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(0, 0, 0, 0.1)',
              '--fontColor': '#fff',
              '--fontSize': '12px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(0, 0, 0, 0.2)',
              '--fontColor': '#fff',
            }"
          >
            {{ $$t("create.subscribe") }}
          </Button>
        </div>
        <div class="fn-inline audio-item-subscribe">
          <IconButton
            size="32px"
            icoSize="16px"
            backgroundColor="rgba(0, 0, 0, 0.1)"
            hoverBackgroundColor="rgba(0, 0, 0, 0.2)"
            @onClick="doClose"
          >
            <img src="@/assets/img/close-ico.png" />
          </IconButton>
        </div>
      </div>
    </div>
    <div class="audio-item-subscribe-pc" v-if="createRenderType == 'pc'">
      <!-- <div class="audio-item-subscribening">
        <div class="aisp-plan-label">Best value plan</div>
        <div class="aisp-plan-content">
          <div class="aisp-plan-price">
            <span class="aisp-plan-price-symbol">$</span>
            <span>24</span>
          </div>
          <div class="aisp-plan-period">/Month</div>
        </div>
      </div> -->
      <div class="audio-item-subscribe-rolling-box flex1 width-0">
        <div class="audio-item-subscribe-rolling-title">
          {{ $$t("create.guid_subscribe_title") }}
        </div>
        <el-carousel
          :interval="5000"
          :autoplay="true"
          height="100%"
          :pause-on-hover="false"
          direction="vertical"
        >
          <el-carousel-item
            v-for="(item, index) in tools.splitArray(
              constGuid.rollingTextDatasMapMobile[$$language()],
              3
            )"
            :key="index"
          >
            <template v-for="(itemC, indexC) in item" :key="indexC">
              <div class="audio-item-subscribe-rolling-text">
                <i class="block"></i><span class="block">{{ itemC }}</span>
              </div>
            </template>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="audio-item-subscribes">
        <div class="fn-inline audio-item-subscribe">
          <Button
            @click="doSubscribe"
            :renderStyle="{
              '--padding': '0',
              '--width': '100px',
              '--height': '42px',
              '--borderRadius': '50px',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)',
              '--fontColor': '#000',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--fontColorHover': '#000',
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
            }"
          >
            {{ $$t("create.subscribe") }}
          </Button>
        </div>
        <div class="fn-inline audio-item-subscribe audio-item-subscribe-close">
          <IconButton
            size="32px"
            icoSize="16px"
            backgroundColor="rgba(255, 255, 255, 0)"
            hoverBackgroundColor="rgba(255, 255, 255, 0.1)"
            @onClick="doClose"
          >
            <img src="@/assets/img/close-ico.png" />
          </IconButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import { storeToRefs } from "pinia"
import { useRouter, useRoute } from "vue-router"

import { $$language, $$t } from "@/i18n/i18n.js"
import tools from "@/utils/tools.js"
import constGuid from "@/config/constGuid.js"

import IconButton from "@/components/basic/button/IconButton.vue"
import Button from "@/components/basic/button/Button.vue"
import LoaderCircle from "@/components/animation/LoaderCircle.vue"

import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore"
import useFeedListStore from "@/store/create/feedListDataStore.js"
const userDataStore = useUserDataStore()
const createLayoutStore = useCreateLayoutStore()
const feedListDataStore = useFeedListStore()

const { createRenderType } =
  storeToRefs(createLayoutStore)
const { isShowSubscribeCard } = storeToRefs(feedListDataStore)

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  pitem: {
    type: Object,
    default: null,
  },
  listRenderType: {
    type: String,
    default: "createdresult", // mysong, likemysong, createdresult
  },
})


const emits = defineEmits(["close"])

const renderData = reactive({
  isShow: false,
  rollingTextIndex: 0,
})

const doClose = () => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  ).appContext.config.globalProperties
  createLayoutStore.setFeedSubscribeIsRender(false)
  globalProperties?.logClickEvent("create_generated_zone_subscribe_ads_close", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  })
}

const doSubscribe = async () => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  ).appContext.config.globalProperties
  if (await userDataStore.checkLoginStatus()) {
    const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
      .appContext?.config?.globalProperties?.$router
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "ad_source",
        membership_source2: "guided_bar",
      },
    })
  }
  globalProperties?.logClickEvent("create_generated_zone_subscribe_ads", {})
}


onMounted(() => {
    const globalProperties = (
      getCurrentInstance() || window?.$getVueCurrentInstance?.()
    ).appContext.config.globalProperties
    globalProperties?.logViewEvent("create_generated_zone_subscribe_ads", {})
})
</script>
<style lang="scss" scope>
.audio-item-subscribe-box {
  padding: 6px 20px 8px 20px;
  // &:hover {
  // background: rgba(255, 255, 255, 0.1);
  //}
  &.audio-item-subscribe-box--mobile {
    padding: 3px 16px 8px 16px;
  }
  .audio-item-subscribe-mobile {
    display: flex;
    align-items: center;
    padding: 12px 10px;
    border-radius: 12px;
    background: #94adff;
    backdrop-filter: blur(20px);
    justify-content: space-between;
    .audio-item-subscribe-rolling-box {
      height: 32px;
      color: #fff;
      padding: 0 10px 0 0;
    }
    .audio-item-subscribe-rolling-text {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      color: #000;
    }
    .audio-item-subscribe {
      margin-left: 8px;
    }
    .el-carousel--vertical {
      height: 100%;
    }
    .el-carousel__item {
      height: 32px;
      display: flex;
      align-items: center;
    }
    .el-carousel__indicators {
      display: none;
    }
  }
  .audio-item-subscribe-pc {
    border-radius: 12px;
    opacity: 1;
    /* 自动布局 */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px 14px 15px 16px;
    background: linear-gradient(99deg, #1a3c8d 0%, #695bc5 47%, #3a1b6f 100%);
    position: relative;
    .audio-item-subscribening {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      color: #ffffff;
      width: 155px;
    }
    .aisp-plan-content {
      margin-top: 12px;
      display: flex;
      align-items: baseline;
      .aisp-plan-price {
        height: 48px;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          font-family: HarmonyOS Sans SC;
          font-size: 42px;
          height: 48px;
          font-weight: bold;
          line-height: normal;
          letter-spacing: 0em;
          background: linear-gradient(134deg, #4fdeff 0%, #e675ff 100%);
          background-clip: text;
          color: transparent;
        }
        .aisp-plan-price-symbol {
          font-size: 35px;
          line-height: 38px;
          height: 38px;
          background: linear-gradient(152deg, #4fdeff 0%, #e675ff 100%);
          background-clip: text;
          color: transparent;
          margin: 4px 4px 0 0;
        }
      }
      .aisp-plan-period {
        font-family: HarmonyOS Sans SC;
        font-size: 14px;
        font-weight: normal;
        line-height: 16px;
        color: rgba(255, 255, 255, 0.5);
        margin-left: 5px;
      }
    }
    .audio-item-subscribes {
      padding: 40px 0 0 0;
    }
    .audio-item-subscribe {
      margin-left: 14px;
    }
    .audio-item-subscribe-close {
      position: absolute;
      right: 16px;
      top: 16px;
    }
    .audio-item-subscribe-rolling-box {
      margin-right: 16px;
      .audio-item-subscribe-rolling-title {
        font-family: HarmonyOS Sans SC;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        color: #ffffff;
      }
      .el-carousel--vertical {
        height: 72px;
        margin-top: 8px;
      }
      .el-carousel__item {
        height: 72px;
        display: flex;
        align-items: center;
        flex-direction: column;
        align-items: start;
      }
      .el-carousel__indicators {
        display: none;
      }
      .audio-item-subscribe-rolling-text {
        display: flex;
        align-items: center;
        height: 24px;
        i {
          height: 20px;
          width: 20px;
          background: url(@/assets/img/wavy-check-ico.png) no-repeat;
          background-size: 100% 100%;
          margin-right: 6px;
        }
        span {
          flex: 1 1 0;
          font-family: HarmonyOS Sans SC;
          font-size: 12px;
          font-weight: normal;
          line-height: 20px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
